var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarningCircle24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF9914"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.496 16.551a1.497 1.497 0 01.91-1.43c.19-.08.39-.11.59-.11.39 0 .77.16 1.05.43s.45.65.47 1.04c0 .2-.02.4-.09.58-.07.19-.18.35-.31.5-.14.14-.3.26-.48.33-.18.08-.38.12-.58.12-.4 0-.78-.14-1.07-.42-.3-.27-.47-.64-.49-1.04zm.5-4v-6c0-.27.11-.52.29-.71.18-.19.44-.29.71-.29.27 0 .52.11.71.29.19.19.29.44.29.71v6c0 .27-.11.52-.29.71a.99.99 0 01-.71.29c-.27 0-.52-.11-.71-.29a.973.973 0 01-.29-.71z",
    fill: "#fff"
  })));
}
export default SvgIconWarningCircle24;